import { Checkbox, FormControlLabel, Grid } from '@mui/material';
import React from 'react';
import Typography from '@mui/material/Typography';
import { DragIndicator } from '@mui/icons-material';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { StorefrontSection } from '../../../api';

type SortableSectionItemProps = {
  id: string;
  label: string;
  onToggle: (section: StorefrontSection, checked: boolean) => void;
};

export const SortableSectionItem: React.FC<SortableSectionItemProps> = ({ id, label, onToggle }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      <Grid container alignItems="center" flexWrap="nowrap">
        <Grid
          {...listeners}
          container
          alignItems="center"
          sx={{ cursor: 'grab', '&:active': { cursor: 'grabbing' }, width: 'auto' }}>
          <DragIndicator sx={{ color: 'text.secondary', marginInlineEnd: 0.5 }} />
        </Grid>
        <FormControlLabel
          control={<Checkbox checked onChange={() => onToggle(id as StorefrontSection, true)} />}
          label={<Typography>{label}</Typography>}
        />
      </Grid>
    </div>
  );
};
